import { Add } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";
import { useGetTitrationsQuery } from "src/api/services/titrationApi";
import { ProductPrice } from "src/api/types";
import DataTable from "src/components/DataTable";
import WhiteCard from "src/components/WhiteCard";
import { useManageModal } from "src/hooks/useManageModal";
import { useColumns } from "./useColumns";
import AddTitrationModal from "./AddTitrationModal";
import { useEffect } from "react";

interface Props {
  price: ProductPrice;
}

const Titrations = ({ price }: Props) => {
  const { data = [] } = useGetTitrationsQuery({ price_id: price.id });
  const [open, { handleClose, handleOpen }] = useManageModal();
  const columns = useColumns();
  const openFromPrice = localStorage.getItem("open-titration");

  useEffect(() => {
    if (openFromPrice == null || openFromPrice === "false") return;

    handleOpen();
  }, [handleOpen, openFromPrice]);

  return (
    <>
      <WhiteCard width={"600px"} gap={3}>
        <Stack gap={1}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography fontWeight={600}>Titrations</Typography>
            <IconButton onClick={handleOpen}>
              <Add color="secondary" />
            </IconButton>
          </Stack>
        </Stack>
        <DataTable columns={columns} data={data} primaryKey="id" />
      </WhiteCard>
      <AddTitrationModal onClose={handleClose} open={open} price={price} />
    </>
  );
};

export default Titrations;
